import React from 'react'
import { Stack } from '~/components/_layouts'
import { Typography, Button } from '~/components/_atoms'
import { useTranslation } from '~/hooks/useTranslation'
import ItalianChatHelp from './ItalianChatHelp'
import ResourceCard from './ResourceCard'

const LiveCoachChat = ({ locale }) => {
  const { t } = useTranslation()

  const steps = [
    t('live_chat.steps.one'),
    t('live_chat.steps.two'),
    t('live_chat.steps.three'),
    t('live_chat.steps.four'),
    t('live_chat.steps.five'),
  ]
  const isItalian = locale === 'it_it'

  return (
    <Stack spacing={6}>
      <Stack spacing={8}>
        {steps.map((step, index) => (
          <div key={index} className="relative min-h-[48px]">
            <div className="flex items-start gap-4">
              <div className="relative">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-willow-brook font-medium text-intoo-green-medium-700">
                  {index + 1}
                </div>
                {index < steps.length - 1 && (
                  <div className="absolute left-1/2 top-[44px] h-[32px] w-1 -translate-x-1/2 bg-willow-brook" />
                )}
              </div>
              {Array.isArray(step) ? (
                <div className="pt-1.5">
                  <Typography
                    variant="body1"
                    color="secondary"
                    component="div"
                    className="font-semibold"
                  >
                    {step[0]}
                  </Typography>
                  <Typography variant="body1" color="secondary">
                    {step[1]}
                  </Typography>
                </div>
              ) : (
                <Typography
                  variant="body1"
                  color="secondary"
                  component="div"
                  className="pt-1.5"
                >
                  {step}
                </Typography>
              )}
            </div>
          </div>
        ))}
      </Stack>

      <Button
        color="secondary"
        className="mb-10 self-start"
        onClick={() =>
          document.querySelector('.yns-btn-coach-chat-list')?.click()
        }
      >
        {t('live_chat.btn_text')}
      </Button>

      {isItalian && <ItalianChatHelp />}

      <ResourceCard />
    </Stack>
  )
}

export default LiveCoachChat
